import InterceptTrack from "./InterceptTrack.js";
import {getDownwindWaypoints} from "../../assets/virtual-flyout/nav-calc.js";
import {getVapp} from "../../assets/virtual-flyout/perf-calc.js";
import {climbVy, descend, setTas} from "../planeSlice.js";
import {getActiveRunway, getAirportDetails} from "../../assets/virtual-flyout/airport-service.js";

const CIRCUIT_DIRECTION  = "left";
const CIRCUIT_HEIGHT = 1000;

export default class JoinDownwind extends InterceptTrack {

    constructor(planeId, airport) {
        super(planeId);
        this.airport = airport;
        this.interceptAngle = 90;
    }

    logAction() {
        this.log(`Joining downwind R${this.runway} ${CIRCUIT_DIRECTION} hand circuit`);
    }

    execute() {
        const planeState = this.getState();
        this.runway = getActiveRunway(this.airport.code, planeState.wind.heading).runway;
        [this.waypoint1, this.waypoint2] = getDownwindWaypoints(this.airport, this.runway, CIRCUIT_DIRECTION);
        super.execute();

        const airportDetails = getAirportDetails(this.airport.code);
        const circuitAltitude = airportDetails.elevation + CIRCUIT_HEIGHT;
        if (planeState.altitude > circuitAltitude) {
            this.dispatch(descend({altitude: circuitAltitude}));
        } else if (planeState.altitude < circuitAltitude) {
            this.dispatch(climbVy({altitude: circuitAltitude}));
        }

        this.dispatch(setTas({tas: getVapp()}));
    }
}